import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Icon } from '@marvelapp/ballpark-components';
// eslint-disable-next-line mobx/missing-observer
export default function Recording(props) {
    return (_jsx(Icon, Object.assign({ viewBox: "0 0 24 24", height: 14, width: 14 }, props, { children: _jsxs("g", { children: [_jsx("path", { d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,21.42A9.42,9.42,0,1,1,21.42,12,9.44,9.44,0,0,1,12,21.42Z", fill: "currentColor" }), _jsx("circle", { cx: "12", cy: "12", r: "4.38", fill: "currentColor" })] }) })));
}
